export default __webpack_public_path__ + "static/media/picture-icon-inaccessible.f848a67f.png";